import styled, { css } from "styled-components";

import { regular, textMd } from "core/fontStyles";
import colors from "core/colors";
import { spacingWithBreakpoints } from "core/spacing";
import { convertPxToRem } from "frontend/components/helpers";

import CheckmarkIcon from "core/ReusableIcons/Checkmark";

export const Section = styled.div`
    ${spacingWithBreakpoints.LGBottom}
`;

// Match legacy page styles
export const Title = styled.div`
    font-family: "Light-45", "Helvetica Neue", "Helvetica", Arial, sans-serif;
    font-size: ${convertPxToRem(24)};
    padding: ${convertPxToRem(8)} 0 ${convertPxToRem(16)};
`;

export const LinkContainer = styled.div`
    ${spacingWithBreakpoints.SMBottom}
`;

// Match legacy page styles
export const ButtonContainer = styled.div.attrs({
    className: "button-container six columns"
})``;

// Match legacy page styles
export const SaveButton = styled.button.attrs({
    type: "submit",
    className: "ui_save slide-in-icon"
})`
    margin-top: 20px !important; // override legacy class
`;

export const SaveButtonText = styled.span``; // helps with the icon-transition when hovering over the button

export const ErrorMessage = styled.div`
    ${textMd}
    ${regular}
    ${spacingWithBreakpoints.SMTop}
    color: ${colors.functional.lightMode.sangria};
`;

export const SuccessMessage = styled.div`
    ${textMd}
    ${regular}
    ${spacingWithBreakpoints.SMTop}
    color: ${colors.alternative.lightMode.basil};
`;

export const SuccessIcon = styled(CheckmarkIcon).attrs({
    size: "sm",
    fillColor: colors.alternative.lightMode.basil
})`
    display: inline-block;
    margin: 0 ${convertPxToRem(5)} ${convertPxToRem(-2)} 0;
`;
